import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import { fonts } from "../../../styles/variables";

type AdventCalendarNavVariant = "navigation" | "topNavigation" | "footer";

const Label = styled.span<{ $variant: AdventCalendarNavVariant }>`
  color: ${(props) => (props.$variant === "navigation" ? "#000" : "inherit")};
  font-family: ${(props) => (props.$variant === "topNavigation" ? fonts.fontBauMedium : "inherit")};
  font-size: inherit;
  white-space: ${(props) => (props.$variant === "footer" ? "normal" : "nowrap")};
`;

const AdventCalendarNavLabel = ({ variant = "navigation" }: { variant?: AdventCalendarNavVariant }) => {
  const { t } = useTranslation(I18N_NAMESPACES.TOP_NAVBAR);

  return (
    <Label $variant={variant}>
      {t(variant === "navigation" ? "topNavbar:adventCalendar" : "topNavbar:adventCalendarShort")}
    </Label>
  );
};

export default AdventCalendarNavLabel;
